import React from "react";
import { connect } from "react-redux";
import { subDays } from "date-fns";
import * as Components from "components";
import constants from "common/constants";
import { toggleGroup } from "actions/groups";
import { isToday } from "date-fns";
import Icon from "../Icon/Icon";
import { shouldFontColorBeLight } from "utils/colors";

class Row extends React.Component {
  render() {
    const { group, user, count, dispatch } = this.props;
    let { numDaysView, offset } = this.props;
    const row = [];

    const groupColor = group.color || "green";

    const isPremium = !user.isPremium && count >= 3;

    if (constants.numDays - numDaysView + 1 === offset) {
      offset++;
      numDaysView--;
    }

    for (let i = 1; i <= numDaysView; i++, offset++) {
      const currentDay = subDays(
        this.props.currentDay,
        constants.numDays - offset
      );

      const today = isToday(currentDay);
      const backgroundColor = today
        ? constants.scales[groupColor][3]
        : constants.scales[groupColor][2];

      const fontColor = shouldFontColorBeLight(backgroundColor)
        ? constants.scales[groupColor][0]
        : constants.scales[groupColor][constants.scales[groupColor].length - 2];

      if (today) {
        row.push(
          <td
            className="today"
            style={{ backgroundColor }}
            key={"group-cell-" + i}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <div style={{ color: fontColor, width: "50%" }}>
                {group.numHabits}
              </div>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name={group.expanded ? "ChevronDown" : "ChevronRight"}
                  size={25}
                  color={fontColor}
                />
              </div>
            </div>
          </td>
        );
      } else {
        row.push(<td style={{ backgroundColor }} key={"group-cell-" + i} />);
      }
    }

    if (isPremium) {
      return (
        <tr key={"group-row-" + group.id} className="freelimit">
          {row}
        </tr>
      );
    }
    return (
      <tr
        onClick={() => dispatch(toggleGroup(group.id))}
        className="group-row"
        key={"group-row-" + group.id}
      >
        {row}
      </tr>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(Row);
